import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogFooter, DialogTitle } from './ui/dialog';
import { DiagramReadOnlyCanvas } from './DiagramReadOnlyCanvas';
import type { Template } from '../data/templates';

interface TemplatePreviewDialogProps {
  template: Template | null;
  onClose: () => void;
}

export default function TemplatePreviewDialog({ template, onClose }: TemplatePreviewDialogProps) {
  const navigate = useNavigate();

  const applyTemplate = (value: Template) => {
    sessionStorage.setItem(
      'selectedTemplate',
      JSON.stringify({ name: value.name, nodes: value.nodes, edges: value.edges })
    );
    navigate('/editor');
  };

  return (
    <Dialog open={!!template} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-[920px]">
        {template && (
          <>
            <DialogTitle>{template.name}</DialogTitle>
            <div className="h-[520px] overflow-hidden rounded-lg border border-border">
              <DiagramReadOnlyCanvas
                key={template.id}
                nodes={template.nodes}
                edges={template.edges}
                className="bg-muted"
              />
            </div>
            <p className="text-[13px] leading-relaxed text-muted-foreground">{template.description}</p>
            <div className="flex flex-wrap gap-1.5">
              {template.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-border px-2 py-0.5 font-mono text-[10.5px] text-muted-foreground"
                >
                  {tag}
                </span>
              ))}
            </div>
            <DialogFooter>
              <button
                onClick={onClose}
                className="ss-press rounded-md border border-border px-4 py-2 text-[13px] font-medium text-foreground transition-colors hover:bg-muted"
              >
                Cancel
              </button>
              <button
                onClick={() => applyTemplate(template)}
                className="ss-press rounded-md bg-foreground px-4 py-2 text-[13px] font-semibold text-background shadow-md transition-opacity hover:opacity-90"
              >
                Use template
              </button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
